export const preferredContact = {
    "en": [
        { name: 'Phone', value: 'phone' },
        { name: 'Email', value: 'email' },
        { name: 'LINE', value: 'line' },
        { name: 'Whatsapp', value: 'whatsapp' },
        { name: 'Wechat - 微信', value: 'wechat' },
        { name: 'Viber', value: 'viber' }
    ],
    "th": [
        { name: 'เบอร์โทร', value: 'phone' },
        { name: 'อีเมล', value: 'email' },
        { name: 'ไลน์', value: 'line' },
        { name: 'Whatsapp', value: 'whatsapp' },
        { name: 'วีแชท', value: 'wechat' },
        { name: 'Viber', value: 'viber' }
    ],
    "cn": [
        { name: '手机号码', value: 'phone' },
        { name: '微信', value: 'wechat' },
        { name: 'LINE', value: 'line' },
        { name: 'Whatsapp', value: 'whatsapp' },
        { name: 'Viber', value: 'viber' },
        { name: '电子邮箱', value: 'email' }
    ],
    "ru": [
        { name: 'Телефон', value: 'phone' },
        { name: 'Email', value: 'email' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'Viber', value: 'viber' },
        { name: 'Telegram', value: 'telegram' }, 
        { name: 'WeChat', value: 'wechat' }
    ],
    "fr": [
        { name: 'Téléphone', value: 'phone' },
        { name: 'E-mail', value: 'email' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'LINE', value: 'line' },
        { name: 'WeChat', value: 'wechat' }
    ],
    "de": [
        { name: 'Telefon', value: 'phone' },
        { name: 'E-Mail', value: 'email' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'LINE', value: 'line' },
        { name: 'WeChat', value: 'wechat' }
    ],
    "it": [
        { name: 'Telefono', value: 'phone' },
        { name: 'Email', value: 'email' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'LINE', value: 'line' },
        { name: 'WeChat', value: 'wechat' }
    ],
    "ja": [
        { name: '電話', value: 'phone' },
        { name: 'メール', value: 'email' },
        { name: 'LINE', value: 'line' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'WeChat', value: 'wechat' },
        { name: 'Viber', value: 'viber' }
    ],
    "ko": [
        { name: '전화', value: 'phone' },
        { name: '이메일', value: 'email' },
        { name: 'LINE', value: 'line' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'WeChat', value: 'wechat' },
        { name: '카카오톡', value: 'kakaotalk' } // Suggested addition for KO market
    ],
    "es": [
        { name: 'Teléfono', value: 'phone' },
        { name: 'Correo electrónico', value: 'email' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'LINE', value: 'line' },
        { name: 'WeChat', value: 'wechat' },
        { name: 'Telegram', value: 'telegram' }
    ],
    "tr": [
        { name: 'Telefon', value: 'phone' },
        { name: 'E-posta', value: 'email' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'LINE', value: 'line' },
        { name: 'WeChat', value: 'wechat' },
        { name: 'Telegram', value: 'telegram' }
    ],
    "he": [
        { name: 'טלפון', value: 'phone' },
        { name: 'אימייל', value: 'email' },
        { name: 'WhatsApp', value: 'whatsapp' },
        { name: 'LINE', value: 'line' },
        { name: 'WeChat', value: 'wechat' },
        { name: 'Viber', value: 'viber' }
    ],
    "ar": [
        { name: 'هاتف', value: 'phone' },
        { name: 'البريد الإلكتروني', value: 'email' },
        { name: 'واتساب', value: 'whatsapp' },
        { name: 'لاين', value: 'line' },
        { name: 'وي شات', value: 'wechat' },
        { name: 'فايبر', value: 'viber' }
    ]
}